// extracted by mini-css-extract-plugin
export var animationContainer = "_o1-0";
export var footer = "_o1-1";
export var gray = "_o1-2";
export var lineItem = "_o1-3";
export var lineItemImage = "_o1-4";
export var lineItemInfo = "_o1-5";
export var lineItemText = "_o1-6";
export var lineItems = "_o1-7";
export var modalContent = "_o1-8";
export var options = "_o1-9";
export var orderName = "_o1-a";
export var refundAmount = "_o1-b";